/**
 * i18next Configuration
 * Internationalization setup for Polish and Ukrainian languages
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import plTranslation from '@/locales/pl.json';
import uaTranslation from '@/locales/ua.json';
import adminDashboardPl from '@/locales/admin/dashboard.pl.json';
import adminDashboardUa from '@/locales/admin/dashboard.ua.json';
import adminOperationsPl from '@/locales/admin/operations.pl.json';
import adminOperationsUa from '@/locales/admin/operations.ua.json';
import adminPropertyPl from '@/locales/admin/property.pl.json';
import adminPropertyUa from '@/locales/admin/property.ua.json';
import adminPeoplePl from '@/locales/admin/people.pl.json';
import adminPeopleUa from '@/locales/admin/people.ua.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      pl: {
        translation: {
          ...plTranslation,
          admin: {
            ...adminDashboardPl,
            ...adminOperationsPl,
            ...adminPropertyPl,
            ...adminPeoplePl,
          },
        },
      },
      ua: {
        translation: {
          ...uaTranslation,
          admin: {
            ...adminDashboardUa,
            ...adminOperationsUa,
            ...adminPropertyUa,
            ...adminPeopleUa,
          },
        },
      },
    },
    lng: 'pl', // default language
    fallbackLng: 'pl',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
